import {jsx as $lL5X2$jsx} from "react/jsx-runtime";
import {parseURLData as $lL5X2$parseURLData} from "web-utility";
import "react";
import {useLocation as $lL5X2$useLocation, useParams as $lL5X2$useParams} from "react-router-dom";





function $ed859e9f463198da$export$369b6b2b30582e8e(Class) {
    return ()=>{
        const location = (0, $lL5X2$useLocation)(), params = (0, $lL5X2$useParams)();
        const { pathname: pathname = "/" , search: search = "" , hash: hash = ""  } = location;
        const path = pathname + search + hash;
        const match = {
            url: globalThis.location.origin + path,
            path: path,
            params: params
        }, query = (0, $lL5X2$parseURLData)(search);
        return /*#__PURE__*/ (0, $lL5X2$jsx)(Class, {
            location: location,
            match: match,
            query: query
        });
    };
}


export {$ed859e9f463198da$export$369b6b2b30582e8e as withRouter};
//# sourceMappingURL=index.esm.js.map
